import { useScriptMode } from "../../contexts/ScriptModeContext";
import SendNotificationForm from "./components/SendNotificationForm";
import NotificationHistoryList from "./components/NotificationHistoryList";
import DeviceStatsCard from "./components/DeviceStatsCard";

/** Duyurular: solda gönderim formu, sağda gönderim geçmişi. */
export default function NotificationsPage() {
  const { t } = useScriptMode();
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-2xl font-SemiBold text-terakkiPrimaryDark dark:text-[#8FC9CA]">{t("notif_page_title")}</h1>
      <DeviceStatsCard />
      {/*
        Yükseklik SOLDAKİ formun boyu kadar olmalı. items-start ile her sütun
        kendi boyunda kalır; sağ sütun ayrıca self-stretch ile satır boyuna
        gerilir ama içindeki kart absolute olduğu için satır yüksekliğine
        katkı vermez — yani satırı form belirler, liste o kutunun içinde kayar.
        Dar ekranda tek sütuna düşünce absolute devre dışı, kart normal akar.
      */}
      <div className="tk-stagger grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
        <SendNotificationForm />
        <div className="relative lg:self-stretch">
          <div className="lg:absolute lg:inset-0">
            <NotificationHistoryList />
          </div>
        </div>
      </div>
    </div>
  );
}
